import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface BannerCSSStyle extends UIComponentCSSStyle
{
    getImgCSSStyle(): object;
    getIndicatorCSSStyle(): object;
    getCarouselDivCSSStyle():object;

}

export class BannerCSSStyleImpl extends UIComponentCSSStyleImpl implements BannerCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
           
        };
    }
    getIndicatorCSSStyle(): object
    {
        return {
            height: '12px', width: '12px', borderRadius: "100%", cursor: "context-menu"
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            height: '300px', width: '100%', objectFit: 'cover', cursor: "pointer"
        };
    }

    getCarouselDivCSSStyle():object
    {
        return{
            marginLeft: "0px", marginRight: "0px", marginTop: "0px"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercss.tsx